import { BaseMutations } from '@/store/base-mutations';
import { AlfaApiLoanApplications } from '@/modules/alfa-api-loan-applications/types';
import AlfaApiLoanApplicationsState from './state';

export default class AlfaApiLoanApplicationsMutations extends BaseMutations<AlfaApiLoanApplicationsState> {
  SET_ALFA_API_LOAN_APPLICATIONS(data: AlfaApiLoanApplications.AlfaApiLoanApplication[]) {
    this.state.alfaApiLoanApplications = data;
  }

  SET_ALFA_API_LOAN_APPLICATIONS_LOADING(value: boolean) {
    this.state.alfaApiLoanApplicationsLoading = value;
  }

  SET_FILTERS_ORGANIZATION_IDS(value: number[]) {
    this.state.filters.organizationIds = value;
  }

  SET_FILTERS_STATUS_IDS(value: number[]) {
    this.state.filters.statusIds = value;
  }

  SET_FILTERS_ORDER_IDS(value: number[]) {
    this.state.filters.orderIds = value;
  }

  SET_FILTERS_CREATED_DATE_RANGE(value: string[]) {
    this.state.filters.createdDateRange = value;
  }

  SET_FILTERS_ORDER_DATE_RANGE(value: string[]) {
    this.state.filters.orderDateRange = value;
  }
}
